package space.stanton.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import space.stanton.components.widgets.NavScaffold


@Suppress("SpellCheckingInspection")
@JsModule("highlight.js")
@JsNonModule
external val hljs: dynamic

external interface HighlightJsOptions {
    var language: String
}

class HighlightJsOptionsImp(override var language: String) : HighlightJsOptions

@Page
@Composable
fun HomePage() {
    NavScaffold {
        BlogPostList()
    }
}


